module.exports = __webpack_public_path__ + "media/images/svgs/jersey_no_7_icon-f7bbfa74aa6ba53a2abec6fcf86163db.svg";